// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-statique {
  padding: 2rem;
}

.mentions-date-maj {
  font-size: 1.25rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
  font-style: normal;
}

.page-statique-contenu {
  color: #374151;
  line-height: 1.7;
}

.page-statique-contenu h1 {
  color: #f97316;
  font-size: 2.4rem;
  margin-top: 2rem;
  margin-bottom: 0.75rem;
}

.page-statique-contenu h1:first-child,
.page-statique-contenu h2:first-child,
.page-statique-contenu h3:first-child {
  margin-top: 0;
}

.page-statique-contenu h2 {
  color: #f97316;
  font-size: 1.9rem;
  margin-top: 2rem;
  margin-bottom: 0.75rem;
}

.page-statique-contenu h3 {
  color: #f97316;
  font-size: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.page-statique-contenu p {
  margin-bottom: 1rem;
}

.page-statique-contenu ul,
.page-statique-contenu ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

.page-statique-contenu a {
  color: #f97316;
  text-decoration: underline;
}

.page-statique-contenu strong,
.page-statique-contenu b {
  font-weight: bold;
}

.page-statique-contenu em,
.page-statique-contenu i {
  font-style: italic;
}

.page-statique-contenu u {
  text-decoration: underline;
}

.page-statique-contenu s,
.page-statique-contenu del {
  text-decoration: line-through;
}

.page-statique-loading,
.page-statique-error,
.page-statique-vide {
  padding: 2rem;
  text-align: center;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/composants/PageStatique/PageStatique.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".page-statique {\n  padding: 2rem;\n}\n\n.mentions-date-maj {\n  font-size: 1.25rem;\n  color: #6b7280;\n  margin-bottom: 1.5rem;\n  font-style: normal;\n}\n\n.page-statique-contenu {\n  color: #374151;\n  line-height: 1.7;\n}\n\n.page-statique-contenu h1 {\n  color: #f97316;\n  font-size: 2.4rem;\n  margin-top: 2rem;\n  margin-bottom: 0.75rem;\n}\n\n.page-statique-contenu h1:first-child,\n.page-statique-contenu h2:first-child,\n.page-statique-contenu h3:first-child {\n  margin-top: 0;\n}\n\n.page-statique-contenu h2 {\n  color: #f97316;\n  font-size: 1.9rem;\n  margin-top: 2rem;\n  margin-bottom: 0.75rem;\n}\n\n.page-statique-contenu h3 {\n  color: #f97316;\n  font-size: 1.5rem;\n  margin-top: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.page-statique-contenu p {\n  margin-bottom: 1rem;\n}\n\n.page-statique-contenu ul,\n.page-statique-contenu ol {\n  margin-left: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.page-statique-contenu a {\n  color: #f97316;\n  text-decoration: underline;\n}\n\n.page-statique-contenu strong,\n.page-statique-contenu b {\n  font-weight: bold;\n}\n\n.page-statique-contenu em,\n.page-statique-contenu i {\n  font-style: italic;\n}\n\n.page-statique-contenu u {\n  text-decoration: underline;\n}\n\n.page-statique-contenu s,\n.page-statique-contenu del {\n  text-decoration: line-through;\n}\n\n.page-statique-loading,\n.page-statique-error,\n.page-statique-vide {\n  padding: 2rem;\n  text-align: center;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
